import { BannerItem } from "@/types/common/banner";

const BANNER_ACKED_IDS_KEY = "GAIL_banner_ids";

/**
 * Sort banners by severity: error > warning > info > success.
 * Returns a new array (non-mutating).
 */
export function sortBannersByPriority(banners: BannerItem[]): BannerItem[] {
  return banners.toSorted((a, b) => {
    if (a.status === "error" && b.status !== "error") {
      return -1;
    }

    if (a.status === "warning" && b.status !== "error" && b.status !== "warning") {
      return -1;
    }

    if (a.status === "info" && b.status === "success") {
      return -1;
    }

    return 1;
  });
}

/**
 * Returns the list of banner IDs the user has already acknowledged,
 * or an empty array if none.
 */
export function getAcknowledgedBannerIds(): string[] {
  return globalThis.localStorage.getItem(BANNER_ACKED_IDS_KEY)?.split(",") ?? [];
}

/**
 * Persists a banner ID as acknowledged so it won't be shown again.
 */
export function acknowledgeBanner(id: string): void {
  const existing = globalThis.localStorage.getItem(BANNER_ACKED_IDS_KEY);
  if (existing) {
    globalThis.localStorage.setItem(BANNER_ACKED_IDS_KEY, `${existing},${id}`);
  } else {
    globalThis.localStorage.setItem(BANNER_ACKED_IDS_KEY, id);
  }
}
